import CityPage from '../../components/CityPage';

const cityData = {
    name: "Blonville-sur-Mer",
    slug: "blonville-sur-mer",
    postalCode: "14910",
    intro: "Vous recherchez un service de débarras à Blonville-sur-Mer ? CC Débarras 14 intervient sur toute la commune pour vider maisons, caves, greniers et dépendances. Entre Bénerville et Villers-sur-Mer, Blonville-sur-Mer fait partie de notre zone d'intervention régulière sur la Côte Fleurie. Nous traitons toutes les situations : succession, vente immobilière, départ en maison de retraite ou encombrants.",
    nearby: ["Bénerville-sur-Mer", "Villers-sur-Mer", "Saint-Arnoult", "Tourgéville", "Auberville"],
};

const BlonvilleSurMer = () => <CityPage city={cityData} />;

export default BlonvilleSurMer;
